import { GoogleAnalyticsReportRequestTypeEnum } from '../../../api/externalData/enums/google-analytics-report-request-type.enum';

export enum ExternalChartMetricsEnum {
    sessions = 'SESSIONS',
    sessionsNewReturning = 'SESSIONS_NEW_RETURNING',
    users = 'USERS',
    activeUsers = 'ACTIVEUSERS',
    usersNewReturning = 'USERS_NEW_RETURNING',
    usersNew = 'USERS_NEW',
    usersReturning = 'USERS_RETURNING',
    sessionsNew = 'SESSIONS_NEW',
    sessionsReturning = 'SESSIONS_RETURNING'
}

export const externalChartMetricToTopReferralSourcesReportRequestTypeMap: Map<ExternalChartMetricsEnum, GoogleAnalyticsReportRequestTypeEnum> =
    new Map<ExternalChartMetricsEnum, GoogleAnalyticsReportRequestTypeEnum>([
        [ExternalChartMetricsEnum.sessions, GoogleAnalyticsReportRequestTypeEnum.TOP_REFERRAL_SOURCES_SESSIONS],
        [ExternalChartMetricsEnum.sessionsNewReturning, GoogleAnalyticsReportRequestTypeEnum.TOP_REFERRAL_SOURCES_NEW_RETURNING_SESSIONS],
        [ExternalChartMetricsEnum.users, GoogleAnalyticsReportRequestTypeEnum.TOP_REFERRAL_SOURCES_USERS],
        [ExternalChartMetricsEnum.usersNewReturning, GoogleAnalyticsReportRequestTypeEnum.TOP_REFERRAL_SOURCES_NEW_RETURNING_USERS],
    ]);


export const externalChartMetricToTopSocialReferrersReportRequestTypeMap: Map<ExternalChartMetricsEnum, GoogleAnalyticsReportRequestTypeEnum> =
    new Map<ExternalChartMetricsEnum, GoogleAnalyticsReportRequestTypeEnum>([
        [ExternalChartMetricsEnum.sessions, GoogleAnalyticsReportRequestTypeEnum.TOP_SOCIAL_REFERRERS_SESSIONS],
        [ExternalChartMetricsEnum.users, GoogleAnalyticsReportRequestTypeEnum.TOP_SOCIAL_REFERRERS_USERS],
    ]);
